document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    document.querySelectorAll('.grid-swiper').forEach(function (swiperObject) {
        new Swiper(swiperObject.querySelector('.swiper'), {
            slidesPerView: 'auto',
            spaceBetween: 16,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            grabCursor: true,
            speed: 700,
            pagination: {
                el: swiperObject.querySelector('.swiper-pagination'),
                type: 'progressbar',
            },
            navigation: {
                nextEl: swiperObject.querySelector('.swiper-button-next'),
                prevEl: swiperObject.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                768: {
                    spaceBetween: 32,
                    slidesOffsetBefore: 40,
                    slidesOffsetAfter: 40,
                },
                1024: {
                    spaceBetween: 40,
                    slidesOffsetBefore: 40,
                    slidesOffsetAfter: 40,
                },
                1280: {
                    spaceBetween: 40,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
            }
        });
    });

    document.querySelectorAll('.banner-swiper').forEach(function (swiperObject) {
        new Swiper(swiperObject.querySelector('.swiper'), {
            speed: 700,
            loop: true,
            slidesPerView: 1,
            grabCursor: true,
            pagination: {
                el: swiperObject.querySelector('.swiper-pagination'),
                type: 'fraction',
            },
            navigation: {
                nextEl: swiperObject.querySelector('.swiper-button-next'),
                prevEl: swiperObject.querySelector('.swiper-button-prev'),
            },
        });
    });
});

//# sourceMappingURL=swiper-grid.js.map
